import ApiOptions from '~/api/v4/api-options';
import Client from '~/types/api/api-module';

const BASE_URL = `${process.env.API_VPNONTRADER_HOST}/v1/loans`;

export default Client.wrap({
  getUserLoanDetails() {
    return this.get(`${BASE_URL}/user-details`, 'loan.*.*', {
      enableAuthHeader: true,
      ...new ApiOptions(),
    });
  },
  getDisbursement(id: string) {
    return this.get(`${BASE_URL}/disbursements/${id}`, 'loan.*.*', {
      enableAuthHeader: true,
      ...new ApiOptions(),
    });
  },
  listRepayments(disbursementId, requestPayload) {
    return this.get(`${BASE_URL}/disbursements/${disbursementId}/repayments`, 'loan.*.*', {
      enableAuthHeader: true,
      ...new ApiOptions({ requestPayload }),
    });
  },
});
